import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';
import { useMemo } from 'react';

export const useSessionsTableColumns = () => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = useMemo(
    () => [
      {
        id: 'sessionName',
        type: 'text',
        title: t('sessions:table.sessionName'),
        filterType: 'search',
        sortable: true,
      },
      {
        id: 'examType',
        type: 'text',
        title: t('sessions:table.examType'),
        filterType: 'search',
        sortable: true,
      },
      {
        id: 'subject',
        type: 'text',
        title: t('sessions:table.subject'),
        filterType: 'search',
        sortable: true,
      },
      {
        id: 'isConfigured',
        type: 'text',
        title: t('sessions:table.isConfigured'),
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'sheetCode',
        type: 'text',
        title: t('sessions:table.sheetCode'),
        filterType: 'search',
        sortable: true,
      },
      {
        id: 'year',
        type: 'text',
        title: t('sessions:table.year'),
        filterType: 'search',
        sortable: true,
      },
      {
        id: 'month',
        type: 'text',
        title: t('sessions:table.month'),
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'sourceSystemName',
        type: 'text',
        title: t('sessions:table.sourceSystemName'),
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'archive',
        type: 'date',
        title: 'Archiwum',
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'state',
        type: 'text',
        title: 'Stan',
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'actions',
        type: 'actions',
        title: 'Akcje',
        filterType: null,
        skipEnterMethod: true,
      },
    ],
    [t],
  );
  return { columns };
};
